import React from "react";
import MapComponent from "../../components/GoogleMap/component/GoogleMap";
import Config from "../../config";
import { htmlDecode } from "../../core";
import { Project } from "../../core/api/models/project";

interface Props {
    locations: {
        lat: number;
        lng: number;
        name: string;
    }[] | undefined
    properyData: any
}

export function SearchPropertiesMapView({ locations, properyData }: Props) {
    return (
        <div className="shortlist-table-outer">
            <div className="my-4 d-flex">
                {!!locations?.length && (
                    <MapComponent
                        apiKey={Config.SITE_VISIT_GOOGLE_MAP_API_KEY}
                        locations={locations || []}
                        width="70%"
                        showNumberLabel={true}
                    />
                )}

                <div className="map-view-pointer">
                    <table className="table w-100">
                        {properyData?.data?.map((item:Project, index:number) => {
                            return (
                                <>
                                    <tr className="require-row">
                                        <td
                                            className="p-2 border-bottom font-sm"
                                            style={{ maxWidth: "30px", width: "30px" }}
                                        >
                                            <div className="py-1">
                                                <label>{index + 1}</label>
                                            </div>
                                        </td>
                                        <td
                                            className="py-2 border-bottom font-sm"
                                            style={{ width: "60px", maxWidth: "60px" }}
                                        >
                                            <div className="py-1 cursor-pointer">
                                                <img
                                                    src={
                                                        item.projectBannerImage ||
                                                        require(`../../assets/images/color-noimage-lg.png`)
                                                    }
                                                    alt={item.projectName}
                                                    width={59}
                                                    height={45}
                                                    className="img-cover"
                                                />
                                            </div>
                                        </td>
                                        <td
                                            className="py-2 border-bottom font-sm"
                                            style={{ width: "280px", maxWidth: "280px" }}
                                        >
                                            <div className="py-1 w-100 px-3">
                                                <div className="font-sm text-truncate cursor-pointer">
                                                    {item.projectName}
                                                </div>
                                                <div className="font-xs text-gray-500">
                                                    {htmlDecode(item.projectAddress1)}
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </>
                            );
                        })}
                    </table>
                </div>
            </div>
        </div>
    );
}